import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatTabsModule } from '@angular/material/tabs';
import { StencilsModule } from '@vendasta/store';
import { VaIconModule, VaSearchBoxModule } from '@vendasta/uikit';

const IMPORTS = [
  CommonModule,
  FormsModule,
  ReactiveFormsModule,
  MatCheckboxModule,
  MatIconModule,
  MatListModule,
  MatFormFieldModule,
  MatCardModule,
  MatButtonModule,
  MatProgressSpinnerModule,
  MatListModule,
  MatPaginatorModule,
  MatTabsModule,
  MatDialogModule,
  VaIconModule,
  VaSearchBoxModule,
  MatRadioModule,
  StencilsModule,
];

@NgModule({
  imports: IMPORTS,
  exports: IMPORTS,
})
export class SharedModule {}
